import z from "zod";
import type { Context } from "hono";
import type { Models } from "@appwrite.io/console";

export const createSiteDeploymentRequestBodySchema = z.object({
  commitSha: z.string(),
  siteName: z.string().optional(),
});

export type CreateSiteDeploymentRequestBody = z.infer<
  typeof createSiteDeploymentRequestBodySchema
>;

export type CreateSiteDeploymentResponseBody = {
  success: true;
  data: {
    siteId: string;
    deploymentId: string;
    deployment: Models.Deployment;
    stageDomain: string;
  };
};

export type CreateSiteDeploymentHandlerReturnType = Promise<
  ReturnType<
    typeof Context.prototype.json<
      | CreateSiteDeploymentResponseBody
      | { error: string }
      | { errors: z.ZodIssue[] }
      | string
    >
  >
>;
